import { Flex, Image, Text } from '@chakra-ui/react';
import { SaleTypeDisplay } from './components/SaleTypeDisplay.tsx';
import { SaleDateDisplay } from './components/SaleDateDisplay.tsx';
import { useUpcomingAuctionCardContent } from './hooks/useUpcomingAuctionCardContent.tsx';
import { AuctionCard } from './components/AuctionCard.tsx';
import { SaleModel } from '../../../../types.ts';
import { AuctionCardLinks } from './AuctionCardLinks.tsx';

export const UpcomingAuctionCard = (model: SaleModel) => {
  const {
    name,
    description,
    color,
    saleTypeText,
    saleDate,
    imageSrc,
    customerUrl,
    customerText,
    saleCatalogueUrl,
    saleCatalogueText,
    videoText,
    videoUrl,
    websiteLinkText,
    websiteLinkUrl,
    infoDocumentText,
    infoDocumentUrl,
    saleUrl
  } = useUpcomingAuctionCardContent(model);

  const handleCardClick = () => {
    window.location.href = saleUrl;
  };

  return (
    <AuctionCard color={color} onClick={handleCardClick}>
      <Flex justify='space-between' direction={{ base: 'column-reverse', sm: 'row' }}>
        <AuctionCardLinks
          hideFrom={'sm'}
          saleCatalogueText={saleCatalogueText}
          saleCatalogueUrl={saleCatalogueUrl}
          customerText={customerText}
          customerUrl={customerUrl}
          videoText={videoText}
          videoUrl={videoUrl}
          infoDocumentText={infoDocumentText}
          infoDocumentUrl={infoDocumentUrl}
        />
        <Flex direction={'column'} padding={'8px'}>
          <Text paddingY={'4px'} fontSize={'md'} fontWeight={'semibold'}>
            {name}
          </Text>
          {imageSrc && <Image width={'600px'} rounded='md' src={imageSrc} alt={`${name} Image`} />}
          <Text hideBelow={'sm'} fontSize={'sm'}>
            {description}
          </Text>
        </Flex>
        <Flex direction={'column'}>
          <Flex direction={{ sm: 'column-reverse', lg: 'row' }} gap={{ lg: '12px' }}>
            <SaleDateDisplay saleDate={saleDate} />
            <SaleTypeDisplay text={saleTypeText} color={color} />
          </Flex>
          <AuctionCardLinks
            hideBelow={'sm'}
            saleCatalogueText={saleCatalogueText}
            saleCatalogueUrl={saleCatalogueUrl}
            customerText={customerText}
            customerUrl={customerUrl}
            videoText={videoText}
            videoUrl={videoUrl}
            websiteLinkText={websiteLinkText}
            websiteLinkUrl={websiteLinkUrl}
            infoDocumentText={infoDocumentText}
            infoDocumentUrl={infoDocumentUrl}
          />
        </Flex>
      </Flex>
    </AuctionCard>
  );
};
